import { useState } from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import classNames from "classnames";
import { Eye, EyeOff } from "lucide-react";

export const Input = ({
  label = null,
  helpText = "",
  placeholder = "",
  disabled = false,
  type = "text",
  className,
  error,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Form.Group className={`input-form ${className ? className : ""}`}>
      {(label || helpText) && (
        <div className="d-flex justify-content-between">
          {label && (
            <Form.Label className="input-form-label">{label}</Form.Label>
          )}
          {helpText && <span className="text-muted">{helpText}</span>}
        </div>
      )}

      <div
        className={type === "password" ? "input-password-wrapper" : undefined}
      >
        <Form.Control
          disabled={disabled}
          className={classNames("input-form-field", {
            "padd-right": type === "password",
            "input-form-field-description": type === "textarea",
          })}
          placeholder={placeholder}
          type={showPassword ? "text" : type}
          isInvalid={Boolean(error)}
          {...props}
        />
        {type === "password" &&
          (showPassword ? (
            <EyeOff size={18} onClick={() => setShowPassword(false)} />
          ) : (
            <Eye size={18} onClick={() => setShowPassword(true)} />
          ))}
      </div>
      {typeof error === "string" && error && (
        <p className="form-error">{error}</p>
      )}
    </Form.Group>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  helpText: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
};
